module.exports = __webpack_public_path__ + "img/carpenter-pool.a0295fbf.webp";